import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import {
  addInvitation,
  removeInvitation,
  removeRole,
  removeItem,
  removeMember,
} from '../../utils/circles/circlesActions';

export const consts = createReqConsts('circles', 'get-guardian-circles', [
  'REMOVE_ITEM',
  'ADD_INVITATION',
  'REMOVE_INVITATION',
  'REMOVE_CAREGIVER',
  'REMOVE_GUARDIAN_ROLE',
  'REMOVE_MEMBER',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'member_guardian_proxy_circles',
  type: 'get',
});

const requestReducer = createReqReducer(consts);

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.REMOVE_ITEM:
      return removeItem(state, payload);
    case consts.ADD_INVITATION:
      return addInvitation(state, payload);
    case consts.REMOVE_INVITATION:
      return removeInvitation(state, payload);
    case consts.REMOVE_CAREGIVER:
      return removeRole(state, payload, { caregiver: false });
    case consts.REMOVE_GUARDIAN_ROLE:
      return removeRole(state, payload, {
        guardian: false,
        proxy: false,
        parent: false,
      });
    case consts.REMOVE_MEMBER:
      return removeMember(state, payload);
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/circles/get-guardian-circle.js